import React from "react";
import { Link } from "react-router-dom";

export default function PostsTable({
  rows,
  onDeleteLocal,
  showKind = true,
  showStatus = false,
  showPreview = false,
  kind,
  profileSlug = "",
}) {
  const emptyLabel = {
    attraction: "attractions",
    profile: "profiles",
    policy: "policies",
    resource: "resources",
  }[kind] || (kind ? `${kind}s` : "content");

  if (rows.length === 0) return <div>No {emptyLabel} yet.</div>;

  return (
    <table className="posts-table">
      <thead>
        <tr>
          <th className="posts-th">Title</th>
          {showKind && <th className="posts-th">Kind</th>}
          {showStatus && <th className="posts-th th-status">Status</th>}
          <th className="posts-th">Updated</th>
          {showPreview && <th className="posts-th th-preview">Preview</th>}
          <th className="posts-th th-actions"></th>
        </tr>
      </thead>

      <tbody>
        {rows.map((p) => {
          const id = p.id || p.postId;
          const updatedAt = p.updatedAt || p.createdAt;
          const rawStatus = p.status ?? (p.active === true ? "Active" : p.active === false ? "Inactive" : "-");
          const status = String(rawStatus || "-");
          const normalizedStatus = status.toLowerCase();
          const slug = String(p.slug || "").replace(/^\/+|\/+$/g, "");
          const encodePath = value => value.split("/").map(encodeURIComponent).join("/");
          const previewUrl = kind === "attraction"
            ? slug && profileSlug
              ? `https://bouncehouse.com/${encodePath(profileSlug)}/attractions/${encodePath(slug)}`
              : null
            : slug
              ? `https://bouncehouse.com/${encodePath(slug)}`
              : null;
          const previewUnavailableReason = !slug
            ? "A slug is required before this post can be previewed."
            : kind === "attraction" && !profileSlug
              ? "An active profile with a slug is required before attractions can be previewed."
              : undefined;

          return (
            <tr key={id}>
              <td className="posts-td">
                <Link to={`/posts/edit/${id}`} className="title-link">
                  {p.title || "(untitled)"}
                </Link>
              </td>

              {showKind && <td className="posts-td">{p.kind}</td>}

              {showStatus && (
                <td className="posts-td td-status">
                  <span className={`status-badge status-${normalizedStatus.replace(/[^a-z0-9]+/g, "-")}`}>
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </span>
                </td>
              )}

              <td className="posts-td">
                {updatedAt ? new Date(updatedAt).toLocaleString() : "-"}
              </td>

              {showPreview && (
                <td className="posts-td td-preview">
                  {previewUrl ? (
                    <a
                      className="preview-btn"
                      href={previewUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Preview
                    </a>
                  ) : (
                    <span
                      className="preview-btn disabled"
                      aria-disabled="true"
                      title={previewUnavailableReason}
                    >
                      Preview
                    </span>
                  )}
                </td>
              )}

              <td className="posts-td td-actions">
                <button
                  type="button"
                  className="trash-btn"
                  onClick={() => onDeleteLocal(id)}
                  aria-label={`Delete ${p.title || "post"}`}
                  title="Delete"
                >
                  &#128465;
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
